const selectText = (element: HTMLElement) => {
  const range: Range = document.createRange();
  range.selectNodeContents(element);
  const selection: Selection = window.getSelection();
  alert(element);
  selection.removeAllRanges();
  selection.addRange(range);
};

const deselectText = () => {
  const sel = window.getSelection();
  sel.removeAllRanges();
};

export const copyById = (id: string) => {
  const element = document.getElementById(id);

  if (element != null) {
    if (element instanceof HTMLInputElement) {
      (element as HTMLInputElement).select();
    } else if (element instanceof HTMLTextAreaElement) {
      (element as HTMLTextAreaElement).select();
    } else {
      selectText(element);
    }

    document.execCommand('copy');
    deselectText();
  }
};

export const copyByText = (text: string) => {
  const tempInput = document.createElement('input');
  tempInput.setAttribute('style', 'position: absolute; left: -1000px; top: -1000px');
  tempInput.setAttribute('value', text);
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/copy.tsx